export const hideErrorMessage = (setErrorMessage) => {
  setTimeout(() => setErrorMessage(""), 5000 );
};
